import type { Theme, Mode, ThemeConfig } from '../schemas/theme.schema';

export type { Theme, Mode, ThemeConfig };

export const THEMES: ReadonlyArray<ThemeConfig> = [
	{ id: 'florada', name: 'Florada', color: '#009053' },
	{ id: 'orvalho', name: 'Orvalho', color: '#5A6ACF' },
	{ id: 'cereja', name: 'Cereja', color: '#AE0B10' },
	{ id: 'dourado', name: 'Dourado', color: '#BF871F' },
	{ id: 'torra', name: 'Torra', color: '#73412F' },
] as const;

export const DEFAULT_THEME: Theme = 'orvalho';
export const DEFAULT_MODE: Mode = 'light';

export const STORAGE_KEYS = {
	THEME: 'practium-theme',
	MODE: 'practium-mode',
} as const;
